import {createSlice} from "@reduxjs/toolkit";

const initialUserRolesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  userRoleForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const userRolesSlice = createSlice({
  name: "userRoles",
  initialState: initialUserRolesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUserRoleById
    userRoleFetched: (state, action) => {
      state.actionsLoading = false;
      state.userRoleForEdit = action.payload.userRoleForEdit;
      state.error = null;
    },
    // findUserRoles
    userRolesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createUserRole
    userRoleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.userRole);
    },
    // updateUserRole
    userRoleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.userRoleId === action.payload.userRole.userRoleId) {
          return action.payload.userRole;
        }
        return entity;
      });
    },
    // deleteUserRole
    userRoleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.userRoleId !== action.payload.userRoleId);
    },
    // deleteUserRoles
    userRolesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.userRoleId)
      );
    },
  }
});
